/* eslint-disable no-unused-vars */
import {API_URL} from '../constants/index.js';

import {
    WORKORDER,
    WORKORDER_SUCCESS,
    WORKORDER_ERROR,
    ADD_WORKORDER,
    ADD_WORKORDER_SUCCESS,
    ADD_WORKORDER_ERROR,
    UPDATE_WORKORDER,
    UPDATE_WORKORDER_SUCCESS,
    UPDATE_WORKORDER_ERROR,
    DELETE_WORKORDER,
    DELETE_WORKORDER_ERROR,
    DELETE_WORKORDER_SUCCESS,
    CLOSE_WORKORDER,
    CLOSE_WORKORDER_ERROR,
    CLOSE_WORKORDER_SUCCESS,
    SYNC_WORKORDERS_TELS_WORKHUBS,
    SYNC_WORKORDERS_TELS_WORKHUBS_SUCCESS,
    SYNC_WORKORDERS_TELS_WORKHUBS_ERROR,
} from '../constants/workOrderConstants.js';
import {GeneralAlert} from '../components/Alert/Alert';
import { sweetAlert } from '../components/Alert/sweetAlert.jsx';
import { HeadsetRounded } from '@material-ui/icons';


//#region WORKORDER (ALL - BYID)
export function getworkOrder(data) {
    return {
        type: WORKORDER,
        data
    }
}

export function getworkOrderSuccess(data) {
    return {
        type: WORKORDER_SUCCESS,
        data
    }
}

export function getworkOrderError(data) {
    return {
        type: WORKORDER_ERROR,
        data
    }
}

export function getAllWorkOrders(data) {
    return dispatch => {
        dispatch(getworkOrder());
        fetch(API_URL+'workorders/workordersByCommunity',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getworkOrderSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getworkOrderError(error));
            })
    }
}

export function getWorkOrderById(id) {
    return dispatch => {
        dispatch(getworkOrder());
        fetch(API_URL+'workorders/workorders/' + id,
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => res.json())
            .then(res => {
                
                dispatch(getworkOrderSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getworkOrderError(error));
            })
    }
}

//#endregion


//#region ADD WORKORDER

    export function newworkOrder(data) {
        return {
            type: ADD_WORKORDER,
            data
        }
    }

    export function newworkOrderSuccess(data) {
        return {
            type: ADD_WORKORDER_SUCCESS,
            data
        }
    }

    export function newworkOrderError(data) {
        return {
            type: ADD_WORKORDER_ERROR,
            data
        }
    }

    export function addWorkOrder(data, communityId, residentId,deviceId, notifyResident,isCommonArea, objStyles) {
        return dispatch => {

            let headers = { 
                'Content-Type':'application/json' ,
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                'Authorization': 'Bearer '+localStorage.getItem('token'),
                'iscommonarea':(isCommonArea)? true: false,
                'notifyresident':(notifyResident)?notifyResident : false,
            }

            if(residentId && residentId.length > 0 && deviceId && deviceId.length > 0){
                headers = { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
                    'iscommonarea':(isCommonArea)? true: false,
                    'notifyresident':(notifyResident)?notifyResident : false,
                    'residentid': (residentId)? residentId : undefined,
                    'deviceid': (deviceId)? deviceId : undefined,
                }
            }else if(residentId && residentId.length > 0){
                headers = { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
                    'iscommonarea':(isCommonArea)? true: false,
                    'notifyresident':(notifyResident)?notifyResident : false,
                    'residentid': (residentId)? residentId : undefined,
                }
            }
            
            dispatch(newworkOrder());
            fetch(API_URL+'workorders/workordersByCommunity/'+communityId,
                {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: headers
                })
                .then(res => {
                    dispatch(newworkOrderSuccess(res));
                    return res;
                })
                .then( () =>{
                    const message = `The repair has been added successfully`

                    sweetAlert('success', message, 'add_repair_success', objStyles);
                    // GeneralAlert('success',message);
                })
                .catch(error => {
                    dispatch(newworkOrderError(error));
                    const message = `An ERROR occurred trying to add the workOrder`

                    sweetAlert('error', message, 'add_repair_error', objStyles);
                    // GeneralAlert('error',message);
                })
        }
    }

//#endregion

//#region UPDATE WORKORDER

    export function modWorkOrder(data) {
        return {
            type: UPDATE_WORKORDER,
            data
        }
    }

    export function modWorkOrderSuccess(data) {
        return {
            type: UPDATE_WORKORDER_SUCCESS,
            data
        }
    }

    export function modWorkOrderError(data) {
        return {
            type: UPDATE_WORKORDER_ERROR,
            data
        }
    }

    export function updWorkOrder(id, data) {
        return dispatch => {
            dispatch(modWorkOrder());
            fetch(API_URL+'workorders/workordersByCommunity/'+ id,
                {
                    method: 'PUT',
                    body: JSON.stringify(data),
                    headers: { 
                        'Content-Type':'application/json' ,
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Authorization': 'Bearer '+localStorage.getItem('token')
                }
                })
                .then(res => {
                    dispatch(modWorkOrderSuccess(res));
                    return res;
                })
                .then( () =>{
                    const message = `The element ${data.name} has been updated successfully`

                    GeneralAlert('success',message);
                })
                .catch(error => {
                    dispatch(modWorkOrderError(error));

                    const message = `An error occurred when trying to update the workOrder ${data.name} `

                    GeneralAlert('error',message);
                })
        }
    }

//#endregion

//#region DELETE WORKORDER

export function deleteWorkOrder(data) {
    return {
        type: DELETE_WORKORDER,
        data
    }
};

export function deleteWorkOrderSuccess(data) {
  
    return {
        type: DELETE_WORKORDER_SUCCESS,
        data
    }
};

export function deleteWorkOrderError(data) {
    return {
        type: DELETE_WORKORDER_ERROR,
        data
    }
};

export function delWorkOrder(id, data) {
    return dispatch => {
        
        dispatch(deleteWorkOrder());
        
        fetch(API_URL+'workorders/workordersByCommunity/'+ id,
            {
                method: 'DELETE',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => {
                dispatch(deleteWorkOrderSuccess(id));
                return res;
            })
            .then( () =>{
                const message = `The element has been deleted successfully`

                GeneralAlert('success',message);
            })
            .catch(error => {
                dispatch(deleteWorkOrderError(error));

                const message = `An error occurred trying to update the workOrder `

                GeneralAlert('error',message);
            })
    }
};

//#endregion


//#region Close WorkOrderRequest
export function closeWorkOrder(data) {
    return {
        type: CLOSE_WORKORDER,
        data
    }
}

export function closeWorkOrderSuccess(data) {
    return {
        type: CLOSE_WORKORDER_SUCCESS,
        data
    }
}

export function closeWorkOrderError(data) {
    return {
        type: CLOSE_WORKORDER_ERROR,
        data
    }
}


export function closeWorkOrderObject(workOrder){
    return dispatch => {

           fetch(API_URL+'workorders/closeWorkOrder/'+ workOrder._id,
            {
                method: 'PUT',
                 headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => {

                dispatch(closeWorkOrderSuccess(workOrder));
                return res;
            })
            .then( () =>{
                const message = `Work order has been closed successfully`

                GeneralAlert('success',message);
            })
            .catch(error => {
                dispatch(closeWorkOrderError(error));

                const message = `An error occurred when trying to closed the repair `

                GeneralAlert('error',message);
            })
    }

}
//#endregion


//#region
    export function syncWorkOrdersTelsAndWorxHubs(data){
        return{
            type: SYNC_WORKORDERS_TELS_WORKHUBS,
            data
        }
    }

    export function syncWorkOrdersTelsAndWorxHubsSuccess(data){
        return{
            type: SYNC_WORKORDERS_TELS_WORKHUBS_SUCCESS,
            data
        }
    }

    export function syncWorkOrdersTelsAndWorxHubsError(data){
        return{
            type: SYNC_WORKORDERS_TELS_WORKHUBS_ERROR,
            data
        }
    }

    export function SyncWorkOrdersTelsAndWorxHubs(communityId){
        return dispatch => {
            const headers = { 
                'Content-Type':'application/json' ,
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                'Authorization': 'Bearer '+localStorage.getItem('token'),
                'communityid': communityId
            }

            return fetch(API_URL+'/workorders/syncWorkOrdersTelsWorxhub',
            {
                method: 'POST',
                 headers: headers
            })
            .then(res => res.json())
            .then(res => {
                dispatch(syncWorkOrdersTelsAndWorxHubsSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(syncWorkOrdersTelsAndWorxHubsError(error));

            })
        }
    }
//#endregion